@if (currentPointTitle()) {
  <span class="point-titles__current ci-paragraph-p1-semibold">
    <span class="current__to">{{ 'a' | translate }} </span>
    <span class="current__point ci-paragraph-p1-regular">{{ currentPointTitle() }}</span>
  </span>
}